import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import * as actions from "../../../../../_redux/private-notices/PrivateNoticesAction";
import { NoticeReceipentType } from "../../../../../../../../_helpers/Helpers";
import * as uiHelpers from "../ParentsUIHelpers";
import { 
  getSelectRow, 
  getHandlerTableChange,  
  NoRecordsFoundMessage,
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../../../../_metronic/_partials/controls";
import { useParentsUIContext } from "../ParentsUIContext";

export function ParentsTable({
  receipentType
}) {
  // Parents UI Context
  const parentsUIContext = useParentsUIContext();
  const parentsUIProps = useMemo(() => {
    return {
      ids: parentsUIContext.ids,
      setIds: parentsUIContext.setIds,
      queryParams: parentsUIContext.queryParams,
      setQueryParams: parentsUIContext.setQueryParams
    };
  }, [parentsUIContext]);

  // Getting curret state of Parents list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.privateNotices }),
    shallowEqual
  );
  const { totalCount, entities, listLoading } = currentState;
  
  // Parents Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    // clear selections list
    parentsUIProps.setIds([]);
    if (receipentType === NoticeReceipentType.Parent) dispatch(actions.getParents(parentsUIProps.queryParams));
    else if (receipentType === NoticeReceipentType.Father) dispatch(actions.getFathers(parentsUIProps.queryParams));
    else if (receipentType === NoticeReceipentType.Mother) dispatch(actions.getMothers(parentsUIProps.queryParams));
    return () => dispatch(actions.cleanListState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [receipentType, parentsUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "name",
      text: "Adı",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "surname",
      text: "Soyadı",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "student",
      text: "Öğrenci",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "section",
      text: "Şube",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "phone",
      text: "Telefon",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      sortCaret: sortCaret,
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: parentsUIProps.queryParams.pageSize,
    page: parentsUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ? entities : [] }
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                parentsUIProps.setQueryParams
              )}
              selectRow={getSelectRow({
                entities,
                ids: parentsUIProps.ids,
                setIds: parentsUIProps.setIds,
              })}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}